<template>
    <div>
        <div class="in-padd">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation" class="active">
                <a href="#pending-payouts" aria-controls="pickl" role="tab" data-toggle="tab">
                  PENDING
                  <span class="hidden-xs">Payouts</span>
                </a>
              </li>
              <li role="presentation">
                <a href="#approved-payouts" aria-controls="home-pickl" role="tab" data-toggle="tab">
                  APPROVED
                  <span class="hidden-xs">Payouts</span>
                </a>
              </li>
              <li role="presentation">
                <a href="#rejected-payouts" aria-controls="credits" role="tab" data-toggle="tab">
                  REJECTED
                  <span class="hidden-xs">Payouts</span>
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane fade in  active" id="pending-payouts">
                <br>
                <div class="transactions" v-if="pendingPayouts.length > 0">
                  <div class="transaction" v-for="credit in pendingPayouts" :key="credit.id">
                    <img
                      class="vertical-center-transform timeline-icon"
                      src="/img/Picklr/paymentTimeline_icon.png"
                    >
                    <div class="green-border-box posRel">
                      <div class="col-xs-12 col-sm-4 transaction-left">
                        <img src="/img/Picklr/payment_icon.png" class="payment-icon">
                        <div class="vertical-center-transform cheque-details">
                          <strong>{{credit.user.name}}</strong><br/>
                          <label>This user has total {{credit.user.current_credits}} credits</label>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-3 date-time">
                        <span class="mr20">
                          <img src="/img/Picklr/date_icon.png">
                          {{credit.created_at | humanReadableDate}}
                        </span>
                      </div>
                      <div class="col-xs-12 col-sm-2 nopadd amount">${{credit.requested_amount}}</div>
                      <div class="col-sm-3" style="margin-top:2%;">
                        <button class="btn btn-success" @click="showApproveModal(credit)">Approve</button> &nbsp;&nbsp;
                        <button class="btn btn-danger" @click="showRejectModal(credit)">Reject</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center mt20" v-if="hasMorePendingPayouts">
                  <button @click="getPendingPayouts" v-if="hasMorePendingPayouts" class="btn-positive">Load more</button>
                </div>
                <h3
                  class="text-center mt20"
                  v-if="(!pendingPayouts || pendingPayouts.length == 0) &&  !loadingPendingPayouts"
                >No Payout Requests!</h3>
                <h3 class="text-center mt20" v-if="loadingPendingPayouts">Loading Requests...</h3>
              </div>
              <div role="tabpanel" class="tab-pane fade" id="approved-payouts">
                <br>
                <div class="transactions" v-if="approvedPayouts.length > 0">
                  <div class="transaction" v-for="credit in approvedPayouts" :key="credit.id">
                    <img
                      class="vertical-center-transform timeline-icon"
                      src="/img/Picklr/paymentTimeline_icon.png"
                    >
                    <div class="green-border-box posRel">
                      <div class="col-xs-12 col-sm-4 transaction-left">
                        <img src="/img/Picklr/payment_icon.png" class="payment-icon">
                        <div class="vertical-center-transform cheque-details">
                          <strong>{{credit.user.name}}</strong><br/>
                          <label>This user has total {{credit.user.current_credits}} credits</label>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-3 date-time">
                        <span class="mr20">
                          <img src="/img/Picklr/date_icon.png">
                          {{credit.created_at | humanReadableDate}}
                        </span>
                      </div>
                      <div class="col-xs-12 col-sm-2 nopadd amount">${{credit.requested_amount}}</div>
                      <div class="col-sm-3" style="margin-top:2%;">
                        <button class="btn btn-success" @click="showDetailsModal(credit)">Details</button> &nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center mt20" v-if="hasMoreApprovedPayouts">
                  <button @click="getApprovedPayouts" v-if="hasMoreApprovedPayouts" class="btn-positive">Load more</button>
                </div>
                <h3
                  class="text-center mt20"
                  v-if="(!approvedPayouts || approvedPayouts.length == 0) &&  !loadingApprovedPayouts"
                >No Payouts!</h3>
                <h3 class="text-center mt20" v-if="loadingPendingPayouts">Loading Requests...</h3>
              </div>
              <div role="tabpanel" class="tab-pane fade" id="rejected-payouts">
                <br>
                <div class="transactions" v-if="rejectedPayouts.length > 0">
                  <div class="transaction" v-for="credit in rejectedPayouts" :key="credit.id">
                    <img
                      class="vertical-center-transform timeline-icon"
                      src="/img/Picklr/paymentTimeline_icon.png"
                    >
                    <div class="green-border-box posRel">
                      <div class="col-xs-12 col-sm-4 transaction-left">
                        <img src="/img/Picklr/payment_icon.png" class="payment-icon">
                        <div class="vertical-center-transform cheque-details">
                          <strong>{{credit.user.name}}</strong><br/>
                          <label>This user has total {{credit.user.current_credits}} credits</label>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-3 date-time">
                        <span class="mr20">
                          <img src="/img/Picklr/date_icon.png">
                          {{credit.created_at | humanReadableDate}}
                        </span>
                      </div>
                      <div class="col-xs-12 col-sm-2 nopadd amount">${{credit.requested_amount}}</div>
                      <div class="col-sm-3" style="margin-top:2%;">
                        <button class="btn btn-success" @click="showDetailsModal(credit)">Details</button> &nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center mt20" v-if="hasMoreRejectedPayouts">
                  <button @click="getRejectedPayouts" v-if="hasMoreRejectedPayouts" class="btn-positive">Load more</button>
                </div>
                <h3
                  class="text-center mt20"
                  v-if="(!rejectedPayouts || rejectedPayouts.length == 0) &&  !loadingRejectedPayouts"
                >No Rejected Payouts!</h3>
                <h3 class="text-center mt20" v-if="loadingRejectedPayouts">Loading Payouts...</h3>
              </div>
            </div>
          </div>

        <!-- Reject Payout Modal -->
        <div class="modal fade" id="rejectPayoutModal" tabindex="-1" role="dialog" aria-labelledby="rejectPayoutModalLabel">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="rejectPayoutModalLabel">Reject Payout Request</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="rejectComments">Rejection Comments:</label>
                  <textarea
                    class="form-control"
                    id="rejectComments"
                    rows="4"
                    placeholder="Please provide a reason for rejecting this payout request..."
                    v-model="rejectComments"
                  ></textarea>
                </div>
                <div class="alert alert-info" v-if="selectedPayout">
                  <strong>Payout Details:</strong><br>
                  User: {{selectedPayout.user ? selectedPayout.user.name : ''}}<br>
                  Amount: ${{selectedPayout.requested_amount || ''}}<br>
                  Payment Method: {{selectedPayout.payment_method || ''}}<br>

                  Request Date: {{selectedPayout.created_at | humanReadableDate}}
                </div>
                <div class="alert alert-warning" v-else>
                  <strong>No payout selected</strong><br>
                  Please select a payout request to reject.
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger" @click="submitRejectPayout" :disabled="!rejectComments.trim()">
                  Reject Payout
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Approve Payout Modal -->
        <div class="modal fade" id="approvePayoutModal" tabindex="-1" role="dialog" aria-labelledby="approvePayoutModalLabel">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="approvePayoutModalLabel">Approve Payout Request</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="approveComments">Approval Comments (Optional):</label>
                  <textarea
                    class="form-control"
                    id="approveComments"
                    rows="4"
                    placeholder="Add any additional comments about this approval..."
                    v-model="approveComments"
                  ></textarea>
                </div>
                <div class="alert alert-info" v-if="selectedPayout">
                  <strong>Payout Details:</strong><br>
                  User: {{selectedPayout.user ? selectedPayout.user.name : ''}}<br>
                  Payment Method: {{selectedPayout.payment_method || ''}}<br>
                  Amount: ${{selectedPayout.requested_amount || ''}}<br>
                  Payment Method: {{selectedPayout.payment_method || ''}}<br>
                  Request Date: {{selectedPayout.created_at | humanReadableDate}}
                </div>
                <div class="alert alert-warning" v-else>
                  <strong>No payout selected</strong><br>
                  Please select a payout request to approve.
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-success" @click="submitApprovePayout">
                  Approve Payout
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Detailed Payout Modal-->
        <div class="modal fade" id="detailPayoutModal" tabindex="-1" role="dialog" aria-labelledby="approvePayoutModalLabel">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="approvePayoutModalLabel">Detailed Payout Request</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                 <label><strong>Comments: </strong>{{selectedPayout.comments}}</label>
                </div>
                <div class="alert alert-info" v-if="selectedPayout">
                  <strong>Payout Details:</strong><br>
                  User: {{selectedPayout.user ? selectedPayout.user.name : ''}}<br>
                  Amount: ${{selectedPayout.requested_amount || ''}}<br>
                  Payment Method: {{selectedPayout.payment_method || ''}}<br>
                  Payout Date: {{selectedPayout.updated_at | humanReadableDate}}
                </div>
                <div class="alert alert-warning" v-else>
                  <strong>No payout selected</strong><br>
                  Please select a payout request to approve.
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'PayoutRequests',
  data () {
    return {
      pendingPayouts: [],
      approvedPayouts: [],
      rejectedPayouts: [],
      pendingPayoutLimit: 100,
      pendingPayoutOffset: 0,
      approvedPayoutLimit: 100,
      approvedPayoutOffset: 0,
      rejectedPayoutLimit: 100,
      rejectedPayoutOffset: 0,
      loadingPendingPayouts: false,
      loadingApprovedPayouts: false,
      loadingRejectedPayouts: false,
      hasMorePendingPayouts: false,
      hasMoreApprovedPayouts: false,
      hasMoreRejectedPayouts: false,
      rejectComments: '',
      selectedPayout: {},
      approveComments: ''
    }
  },
  methods: {
    getPendingPayouts () {
      this.$store.dispatch('getPayouts', { limit: this.pendingPayoutLimit, offset: this.pendingPayoutOffset, status: 'PENDING' }).then((response) => {
        console.log(response)
        this.pendingPayouts.push(...response.body.data)
        this.hasMorePendingPayouts = response.body.data.length === this.pendingPayoutLimit
        this.loadingPendingPayouts = false
      })
    },
    getApprovedPayouts () {
      this.$store.dispatch('getPayouts', { limit: this.approvedPayoutLimit, offset: this.approvedPayoutOffset, status: 'APPROVED' }).then((response) => {
        this.approvedPayouts.push(...response.body.data)
        this.hasMoreApprovedPayouts = response.body.data.length === this.approvedPayoutLimit
      })
    },
    getRejectedPayouts () {
      this.$store.dispatch('getPayouts', { limit: this.rejectedPayoutLimit, offset: this.rejectedPayoutOffset, status: 'REJECTED' }).then((response) => {
        this.rejectedPayouts.push(...response.body.data)
        this.hasMoreRejectedPayouts = response.body.data.length === this.rejectedPayoutLimit
      })
    },

    showRejectModal (payout) {
      this.selectedPayout = payout
      this.rejectComments = '' // Clear previous comments
      $('#rejectPayoutModal').modal('show')
    },
    showDetailsModal (payout) {
      this.selectedPayout = payout
      $('#detailPayoutModal').modal('show')
    },
    submitRejectPayout () {
      if (!this.rejectComments.trim()) {
        this.$notify({
          type: 'error',
          text: 'Rejection comments cannot be empty.'
        })
        return
      }
      this.$store.dispatch('rejectPayout', {
        id: this.selectedPayout.id,
        comments: this.rejectComments
      }).then(() => {
        this.$notify({
          type: 'success',
          text: 'Payout rejected successfully!'
        })
        this.refreshPayoutLists()
        $('#rejectPayoutModal').modal('hide')
      }).catch(() => {
        this.$notify({
          type: 'error',
          text: 'Failed to reject payout.'
        })
      })
    },
    showApproveModal (payout) {
      this.selectedPayout = payout
      this.approveComments = '' // Clear previous comments
      $('#approvePayoutModal').modal('show')
    },
    submitApprovePayout () {
      this.$store.dispatch('approvePayout', { id: this.selectedPayout.id, comments: this.approveComments }).then((response) => {
        this.$notify({
          type: 'success',
          text: 'Payout approved successfully!'
        })
        this.refreshPayoutLists()
        $('#approvePayoutModal').modal('hide')
      }).catch(() => {
        this.$notify({
          type: 'error',
          text: 'Failed to approve payout.'
        })
      })
    },
    refreshPayoutLists () {
      this.pendingPayouts = []
      this.approvedPayouts = []
      this.rejectedPayouts = []
      this.getPendingPayouts()
      this.getApprovedPayouts()
      this.getRejectedPayouts()
    }
  },

  mounted () {
    this.getPendingPayouts()
    this.getApprovedPayouts()
    this.getRejectedPayouts()
  }
}
</script>
<style scoped>

.transactions,
.transaction {
  padding-left: 30px;
}

.transaction {
  border-left: 1px solid #d3d3d3;
  position: relative;
  padding-top: 8px;
  padding-bottom: 8px;
}

.transaction:last-child {
  padding-bottom: 0;
}

.transaction:first-child:before {
  content: " ";
  border: 1px solid #d3d3d3;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: -4px;
}

.transaction .timeline-icon {
  width: 20px;
  height: 20px;
  left: -10px;
}

.transaction .edit-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 28px;
  height: 27px;
  display: none;
  border-top-right-radius: 3px;
}

.transaction:hover .edit-icon,
.transaction:focus .edit-icon {
  display: block;
}

.transaction-left {
  padding: 15px;
}

.transaction-left .cheque-details {
  width: calc(100% - 75px);
  display: inline-block;
  font-size: 17px;
  color: rgba(90, 90, 90, 0.8);
  left: 90px;
}

.transaction-left .cheque-details strong {
  font-size: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
}

.payment-icon {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.date-time {
  font-weight: 500;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
}

.date-time img {
  vertical-align: text-top;
}

.amount {
  font-weight: 500;
  font-size: 22px;
  color: rgba(0, 0, 0, 0.9);
  text-align: center;
  background-color: #f7f8f9;
}

.date-time,
.amount {
  line-height: 90px;
  vertical-align: middle;
}

</style>
